import { render, staticRenderFns } from "./depoimentos.vue?vue&type=template&id=07cae83f&scoped=true&"
import script from "./depoimentos.vue?vue&type=script&lang=js&"
export * from "./depoimentos.vue?vue&type=script&lang=js&"
import style0 from "./depoimentos.vue?vue&type=style&index=0&id=07cae83f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cae83f",
  null
  
)

export default component.exports